var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "os-container" }, [
    _c(
      "div",
      { staticClass: "nav" },
      [
        _c(
          "base-button",
          {
            staticClass: "access-btn",
            attrs: { negative: "" },
            on: {
              click: function($event) {
                return _vm.$router.push("/inicio-sesion")
              }
            }
          },
          [
            _vm._v(_vm._s(_vm.$t("login-wrd")) + "\n\t\t\t"),
            !_vm.$uiHelpers.isMobile && !_vm.$uiHelpers.isTablet
              ? _c("base-icon", {
                  attrs: {
                    src:
                      "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                    color: "white"
                  },
                  nativeOn: {
                    mouseover: function($event) {
                      _vm.hover = true
                    },
                    mouseleave: function($event) {
                      _vm.hover = false
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "overlay" }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h3", { staticClass: "mb-4" }, [
        _vm._v("Revolutionizing Access to Legal Services")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(_vm._s(_vm.$t("openlegal.promotion-question")))
      ]),
      _vm._v(" "),
      _vm.subscriptionDone
        ? _c("div", { staticClass: "ctn-shadow" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("openlegal.thanks-subscription")))])
          ])
        : _c(
            "div",
            [
              _c("base-input", {
                staticClass: "d-block d-md-inline-block mr-0 mr-xl-2",
                attrs: {
                  placeholder: _vm.$t("openlegal.enter-your-email"),
                  state: _vm.validateState("email"),
                  validator: _vm.$v.form.email
                },
                model: {
                  value: _vm.$v.form.email.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form.email, "$model", $$v)
                  },
                  expression: "$v.form.email.$model"
                }
              }),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  staticClass: "d-block d-md-inline-block btn-sign-up",
                  attrs: {
                    borderColor: "white",
                    backgroundColor: "transparent",
                    textColor: "white",
                    loading: _vm.$store.state.loading
                  },
                  on: { click: _vm.signUpButtonClicked }
                },
                [
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                      white: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("img", {
        staticClass: "mb-5",
        attrs: { src: "/static-appopensalud/img/logos/openlegal_white.svg" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94f91162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94f91162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/TemporaryHome.vue
// module id = 4219
// module chunks = 54